import { createPixiText, scaleToFit } from '../../../Utils/Utils';
import { PlayerAvatarFrame } from '../../Map/PlayerAvatarFrame';
import { ILeaderBoardPlayer } from './LeaderBoard';
import { SocialSendCoinsBtn } from './SocialSendCoinsBtn';
import { Rectangle, Sprite } from 'pixi.js';

export class LeaderboardFriendTab extends PIXI.Sprite {
    private coinsButton: SocialSendCoinsBtn;
    private playerData: ILeaderBoardPlayer;
    constructor(
        playerData: ILeaderBoardPlayer,
        index: number,
        tabWidth: number,
        tabHeight: number,
        canSendGifts: boolean
    ) {
        super();
        this.playerData = playerData;

        const textureUrl = playerData.isUser
            ? 'mapui/leaderboard-usertag-bg'
            : 'mapui/leaderboard-playertag-bg';
        const textColor = playerData.isUser ? 0xff6600 : 0x006eba;

        const rect = new Sprite(PIXI.utils.TextureCache[textureUrl]);
        this.addChild(rect);

        // add the player rank position (the first 3 have a badge)
        if (index < 3) {
            const rank = new Sprite(
                PIXI.utils.TextureCache[`mapui/leaderboard-playertag-rank${index + 1}`]
            );
            rank.anchor.set(0.5);
            rank.position.set(rect.width * 0.08, rect.height * 0.46);
            this.addChild(rank);
        } else {
            const rank = createPixiText(
                (index + 1).toString(),
                new Rectangle(rect.width * 0.08, rect.height * 0.46, rect.width * 0.2, rect.height),
                'Baloo',
                30,
                28,
                textColor
            );
            this.addChild(rank);
        }

        // add player avatar and name
        const avatar = new PlayerAvatarFrame(playerData.url, false);
        avatar.position.set(rect.width * 0.25, rect.height * 0.46);
        avatar.scale.set(scaleToFit(avatar.width, avatar.height, rect.width, rect.height * 0.9));
        this.addChild(avatar);

        const playerName = createPixiText(
            playerData.name,
            new Rectangle(rect.width * 0.35, rect.height * 0.46, rect.width * 0.4, rect.height),
            'Baloo',
            30,
            28,
            textColor
        );
        playerName.anchor.x = 0; // align left
        this.addChild(playerName);

        // add collecting coins button if the player is not the user
        if (!playerData.isUser) {
            const btnCoins = new SocialSendCoinsBtn(playerData.id, canSendGifts);
            btnCoins.position.set(rect.width * 0.75, rect.height * 0.46);
            this.addChild(btnCoins);
            this.coinsButton = btnCoins;
        }

        // add star icon and amount (text)
        const starIcon = new Sprite(PIXI.utils.TextureCache['commonui/top-hud-starsbar-star']);
        starIcon.anchor.set(0.5);
        starIcon.position.set(rect.width * 0.9, rect.height * 0.3);
        starIcon.scale.set(0.8);
        this.addChild(starIcon);

        const playerStars = createPixiText(
            playerData.stars.toString(),
            new Rectangle(rect.width * 0.9, rect.height * 0.7, rect.width * 0.1, rect.height),
            'Baloo',
            30,
            28,
            textColor
        );
        this.addChild(playerStars);

        this.pivot.x = rect.width / 2;
        this.pivot.y = 0;
    }

    public getPlayerData() {
        return this.playerData;
    }

    public getCoinsButton() {
        return this.coinsButton;
    }
}
